import { FC } from 'react';

interface MeasurementAxisTickProps {
  /** x, y и payload подставляет recharts, клонируя переданный элемент. */
  x?: number;
  y?: number;
  payload?: { value?: number };
  /** Наработка -> эквивалентные часы. Отсутствующие значения не подписываются. */
  equivalentByEngineHours: Map<number, number>;
}

/**
 * Подпись оси X в две строки: наработка машины и под ней эквивалентные часы в скобках.
 *
 *   73724
 *  (78465)
 */
export const MeasurementAxisTick: FC<MeasurementAxisTickProps> = ({
  x = 0,
  y = 0,
  payload,
  equivalentByEngineHours,
}) => {
  const value = payload?.value;
  const equivalentHours = value === undefined ? undefined : equivalentByEngineHours.get(value);

  return (
    <g transform={`translate(${x}, ${y})`}>
      <text textAnchor="middle" fontSize={12} fill="#666" dy={14}>
        {value}
      </text>
      {equivalentHours !== undefined && (
        <text textAnchor="middle" fontSize={11} fill="#999" dy={30}>
          {`(${equivalentHours})`}
        </text>
      )}
    </g>
  );
};
